
const FriendsTempPage = () => {

    return (
        <body
            className="bg-gradient-to-b from-purple-900 via-indigo-900 to-slate-900 text-white pb-20 overflow-x-hidden">

        <header className="pt-12 pb-8 text-center px-4 relative">
            <button id="logout-btn"
                    className="absolute top-5 left-5 bg-white/10 backdrop-blur-md border border-white/20 hover:bg-white/20 text-yellow-200 px-3 py-1.5 rounded-full text-xs font-bold flex items-center gap-1 transition-all z-40"
                    >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                     data-lucide="log-out" aria-hidden="true" className="lucide lucide-log-out w-3 h-3">
                    <path d="m16 17 5-5-5-5"></path>
                    <path d="M21 12H9"></path>
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                </svg>
                로그 아웃
            </button>
            <button id="history-btn"
                    className="absolute top-5 right-5 bg-white/10 backdrop-blur-md border border-white/20 hover:bg-white/20 text-white px-3 py-1.5 rounded-full text-xs font-bold flex items-center gap-1 transition-all z-40"
                    >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                     data-lucide="archive" aria-hidden="true" className="lucide lucide-archive w-3 h-3">
                    <rect width="20" height="5" x="2" y="3" rx="1"></rect>
                    <path d="M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8"></path>
                    <path d="M10 12h4"></path>
                </svg>
                당첨 내역
            </button>
            <div
                className="inline-block px-4 py-1 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 text-yellow-400 text-sm font-bold mb-4">
                ✨ 꽝 없는 100% 당첨!
            </div>
            <h1 className="text-4xl md:text-5xl font-extrabold bg-clip-text text-transparent bg-gradient-to-r from-yellow-300 via-pink-400 to-purple-400 mb-2 drop-shadow-sm">
                LUCKY ROULETTE
            </h1>
        </header>

        <section className="flex flex-col items-center justify-center mb-12 relative z-10">
            <div className="relative w-80 h-80 md:w-96 md:h-96">
                <div
                    className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-4 z-20 w-0 h-0 border-l-[15px] border-l-transparent border-r-[15px] border-r-transparent border-t-[30px] border-t-yellow-400 drop-shadow-lg"></div>

                <div id="wheel"
                     className="roulette-wheel w-full h-full rounded-full border-8 border-yellow-500 shadow-[0_0_40px_rgba(234,179,8,0.3)] bg-white overflow-hidden relative">
                    <div id="wheel-bg" className="w-full h-full rounded-full transition-all"
                         style={{background: "conic-gradient(rgb(255, 107, 107) 0deg, rgb(255, 107, 107) 267.5deg, rgb(78, 205, 196) 267.5deg, rgb(78, 205, 196) 360deg)"}}></div>
                    <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                        <div className="w-3 h-3 bg-white rounded-full z-10 shadow-lg border-2 border-gray-200"></div>
                    </div>
                    <div id="wheel-texts">
                        <div
                            className="absolute w-full text-center top-1/2 left-0 -mt-3 text-white font-bold drop-shadow-md pointer-events-none origin-center whitespace-nowrap"
                            style={{transform: "rotate(133.75deg) translate(0px, -100px) rotate(90deg)", fontSize: "9px"}}>소주/된장찌개
                            1+1 할인 쿠폰
                        </div>
                        <div
                            className="absolute w-full text-center top-1/2 left-0 -mt-3 text-white font-bold drop-shadow-md pointer-events-none origin-center whitespace-nowrap"
                            style={{transform: "rotate(313.75deg) translate(0px, -100px) rotate(90deg)", fontSize: "12px"}}>5000원
                            할인 쿠폰
                        </div>
                    </div>
                </div>

                <button disabled="" id="spin-btn"
                        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-20 h-20 bg-white rounded-full shadow-xl flex items-center justify-center text-indigo-900 font-bold text-xl hover:scale-110 transition-transform z-30 border-4 border-indigo-100 opacity-50 cursor-not-allowed">
                    START
                </button>
            </div>

            <div
                className="mt-8 bg-indigo-800/50 px-6 py-2 rounded-full border border-indigo-500/30 flex items-center gap-2 backdrop-blur-md">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                     data-lucide="gift" aria-hidden="true" className="lucide lucide-gift w-5 h-5 text-yellow-400">
                    <rect x="3" y="8" width="18" height="4" rx="1"></rect>
                    <path d="M12 8v13"></path>
                    <path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"></path>
                    <path d="M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5"></path>
                </svg>
                <span className="text-lg">남은 룰렛권: <strong id="ticket-count"
                                                          className="text-yellow-400 text-xl">0</strong>장</span>
            </div>

            <div id="result-modal"
                 className="hidden mt-4 bg-white text-indigo-900 px-6 py-3 rounded-lg font-bold shadow-lg text-center">
                🎉 축하합니다! <br/><span id="result-text" className="text-pink-600 text-xl"></span> 당첨!
            </div>
        </section>

        <main className="max-w-md mx-auto px-6 space-y-6">
            <div id="login-view"
                 className="bg-white/5 border border-white/10 rounded-2xl p-6 text-center backdrop-blur-sm hidden">
                <p className="text-lg mb-4 text-gray-200">로그인하고 첫 번째 룰렛을 돌려보세요!</p>
                <button id="kakao-login-btn"
                        className="w-full bg-[#FEE500] hover:bg-[#FADB00] text-[#000000]/85 font-bold py-4 rounded-xl flex items-center justify-center gap-3 transition-colors text-lg"
                        disabled="" style={{backgroundColor: "rgb(106, 106, 106)"}}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                         stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                         data-lucide="message-circle" aria-hidden="true"
                         className="lucide lucide-message-circle w-6 h-6 fill-current">
                        <path
                            d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719"></path>
                    </svg>
                    카카오로 3초만에 시작하기
                </button>
            </div>

            <div id="main-view" className="bg-white/10 border border-white/10 rounded-2xl p-6 backdrop-blur-md">
                <div className="flex justify-between items-center mb-6">
                    <h2 className="text-xl font-bold flex items-center gap-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                             stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                             data-lucide="user-plus" aria-hidden="true"
                             className="lucide lucide-user-plus w-5 h-5 text-green-400">
                            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                            <circle cx="9" cy="7" r="4"></circle>
                            <line x1="19" x2="19" y1="8" y2="14"></line>
                            <line x1="22" x2="16" y1="11" y2="11"></line>
                        </svg>
                        친구 초대 현황
                    </h2>
                    <span className="text-sm text-gray-300"><span id="friend-count">1</span> / 4 명</span>
                </div>
                <div id="friend-slots" className="flex justify-between items-center mb-8 gap-2">
                    <div className="flex flex-col items-center gap-2 flex-1">
                        <div
                            className="w-16 h-16 md:w-20 md:h-20 rounded-full flex items-center justify-center relative overflow-hidden transition-all bg-white border-2 border-yellow-400">
                            <img
                                src="https://api.dicebear.com/7.x/avataaars/svg"
                                className="w-full h-full object-cover"/>
                        </div>
                        <span className="text-xs text-gray-300 truncate max-w-[60px]">
                            홍길동
                            </span>
                    </div>
                    <div className="flex flex-col items-center gap-2 flex-1">
                        <div
                            className="w-16 h-16 md:w-20 md:h-20 rounded-full flex items-center justify-center relative overflow-hidden transition-all border-2 border-dashed border-gray-400/50">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                 fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                 stroke-linejoin="round" data-lucide="user-plus" aria-hidden="true"
                                 className="lucide lucide-user-plus w-6 h-6 text-gray-500">
                                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                                <circle cx="9" cy="7" r="4"></circle>
                                <line x1="19" x2="19" y1="8" y2="14"></line>
                                <line x1="22" x2="16" y1="11" y2="11"></line>
                            </svg>
                        </div>
                        <span className="text-xs text-gray-300 truncate max-w-[60px]">
                            친구대기
                            </span>
                    </div>
                    <div className="flex flex-col items-center gap-2 flex-1">
                        <div
                            className="w-16 h-16 md:w-20 md:h-20 rounded-full flex items-center justify-center relative overflow-hidden transition-all border-2 border-dashed border-gray-400/50">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                 fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                 stroke-linejoin="round" data-lucide="user-plus" aria-hidden="true"
                                 className="lucide lucide-user-plus w-6 h-6 text-gray-500">
                                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                                <circle cx="9" cy="7" r="4"></circle>
                                <line x1="19" x2="19" y1="8" y2="14"></line>
                                <line x1="22" x2="16" y1="11" y2="11"></line>
                            </svg>
                        </div>
                        <span className="text-xs text-gray-300 truncate max-w-[60px]">
                            친구대기
                            </span>
                    </div>
                    <div className="flex flex-col items-center gap-2 flex-1">
                        <div
                            className="w-16 h-16 md:w-20 md:h-20 rounded-full flex items-center justify-center relative overflow-hidden transition-all border-2 border-dashed border-gray-400/50">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                 fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                 stroke-linejoin="round" data-lucide="user-plus" aria-hidden="true"
                                 className="lucide lucide-user-plus w-6 h-6 text-gray-500">
                                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                                <circle cx="9" cy="7" r="4"></circle>
                                <line x1="19" x2="19" y1="8" y2="14"></line>
                                <line x1="22" x2="16" y1="11" y2="11"></line>
                            </svg>
                        </div>
                        <span className="text-xs text-gray-300 truncate max-w-[60px]">
                            친구대기
                            </span>
                    </div>
                </div>
                <div className="space-y-3">
                    <button id="copy-link-btn"
                            className="w-full bg-indigo-600 hover:bg-indigo-500 text-white font-bold py-3 rounded-xl flex items-center justify-center gap-2 transition-all shadow-lg active:scale-95">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                             stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                             data-lucide="share2" aria-hidden="true" className="lucide lucide-share2 w-5 h-5">
                            <circle cx="18" cy="5" r="3"></circle>
                            <circle cx="6" cy="12" r="3"></circle>
                            <circle cx="18" cy="19" r="3"></circle>
                            <line x1="8.59" x2="15.42" y1="13.51" y2="17.49"></line>
                            <line x1="15.41" x2="8.59" y1="6.51" y2="10.49"></line>
                        </svg>
                        친구 초대 링크 복사하기
                    </button>
                </div>
            </div>
        </main>

        <div id="history-modal-overlay"
             className="hidden fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-center justify-center p-4">
            <div
                className="bg-white w-full max-w-sm rounded-2xl overflow-hidden shadow-2xl animate-[fade-in_0.3s_ease-out]">
                <div className="bg-indigo-900 p-4 flex justify-between items-center">
                    <h3 className="text-white font-bold text-lg flex items-center gap-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                             stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                             data-lucide="ticket" aria-hidden="true"
                             className="lucide lucide-ticket w-5 h-5 text-yellow-400">
                            <path
                                d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"></path>
                            <path d="M13 5v2"></path>
                            <path d="M13 17v2"></path>
                            <path d="M13 11v2"></path>
                        </svg>
                        나의 당첨 보관함
                    </h3>
                    <button id="close-history-btn" className="text-gray-300 hover:text-white transition-colors">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                             stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                             data-lucide="x" aria-hidden="true" className="lucide lucide-x w-6 h-6">
                            <path d="M18 6 6 18"></path>
                            <path d="m6 6 12 12"></path>
                        </svg>
                    </button>
                </div>
                <div className="p-4 bg-gray-50 min-h-[300px] max-h-[50vh] overflow-y-auto no-scrollbar relative">
                    <ul id="history-list" className="space-y-3"></ul>
                    <div id="empty-history"
                         className="hidden absolute inset-0 flex flex-col items-center justify-center text-gray-400">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                             stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                             data-lucide="ghost" aria-hidden="true"
                             className="lucide lucide-ghost w-12 h-12 mb-2 opacity-50">
                            <path d="M9 10h.01"></path>
                            <path d="M15 10h.01"></path>
                            <path
                                d="M12 2a8 8 0 0 0-8 8v12l3-3 2.5 2.5L12 19l2.5 2.5L17 19l3 3V10a8 8 0 0 0-8-8z"></path>
                        </svg>
                        <p className="text-sm">아직 당첨 내역이 없습니다.</p>
                    </div>
                </div>
                <div className="p-4 bg-white border-t border-gray-100">
                    <button id="close-history-btn-btm"
                            className="w-full py-3 bg-gray-200 text-gray-700 font-bold rounded-xl hover:bg-gray-300 transition-colors">닫기
                    </button>
                </div>
            </div>
        </div>

        <div id="invite-modal-overlay"
             className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-center justify-center p-4 hidden">
            <div
                className="bg-white w-full max-w-sm rounded-2xl overflow-hidden shadow-2xl animate-[fade-in_0.3s_ease-out] text-center p-6 relative">
                <div
                    className="w-16 h-16 bg-indigo-100 rounded-full flex items-center justify-center mx-auto mb-4 animate-bounce">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                         stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                         data-lucide="mail-open" aria-hidden="true"
                         className="lucide lucide-mail-open w-8 h-8 text-indigo-600">
                        <path
                            d="M21.2 8.4c.5.38.8.97.8 1.6v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V10a2 2 0 0 1 .8-1.6l8-6a2 2 0 0 1 2.4 0l8 6Z"></path>
                        <path d="m22 10-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 10"></path>
                    </svg>
                </div>
                <h3 className="text-gray-900 font-bold text-xl mb-2">초대장이 도착했습니다! 💌</h3>
                <p className="text-gray-600 mb-6 leading-relaxed">
                    <span className="text-indigo-600 font-bold" id="inviter-name">친구</span>님의 초대를 받으셨습니다.<br/>
                    초대를 수락하시겠습니까?
                </p>
                <div className="flex gap-3">
                    <button id="btn-ignore-invite"
                            className="flex-1 py-3 bg-gray-100 text-gray-500 font-bold rounded-xl hover:bg-gray-200 transition-colors">닫기
                    </button>
                    <button id="btn-accept-invite"
                            className="flex-1 py-3 bg-indigo-600 text-white font-bold rounded-xl hover:bg-indigo-500 transition-colors shadow-lg shadow-indigo-200">수락하기
                    </button>
                </div>
            </div>
        </div>

        <footer className="mt-12 text-center text-xs text-gray-500 px-6 space-y-2 pb-8">
            <p>© headless Inc. All rights reserved</p>
        </footer>
        </body>
    )
}

export default FriendsTempPage